module.exports = __webpack_public_path__ + "static/home-artist-management-mobile-1bd5639cff79b521a999d155d750a2ca.png";